import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { useIsLoggedIn } from '../../hooks/useIsLoggedIn';

type PreviewPublishContextValue = {
    canPublish: boolean | null;
    isLoggedIn: boolean;
    setCanPublish: (value: boolean | null) => void;
};

const PreviewPublishContext = createContext<PreviewPublishContextValue | null>(null);

export function PreviewPublishProvider({ children }: { children: ReactNode }) {
    const isLoggedIn = useIsLoggedIn();
    const [canPublish, setCanPublish] = useState<boolean | null>(null);
    const value = useMemo(
        () => ({ canPublish, isLoggedIn, setCanPublish }),
        [canPublish, isLoggedIn]
    );

    return (
        <PreviewPublishContext.Provider value={value}>{children}</PreviewPublishContext.Provider>
    );
}

export function usePreviewPublish(): PreviewPublishContextValue {
    const value = useContext(PreviewPublishContext);

    if (!value) {
        throw new Error('usePreviewPublish must be used within PreviewPublishProvider');
    }

    return value;
}
